import { Injectable } from '@angular/core';

import { ITeaserBetSavedState, ITeaserBetState, defaultTeaserBetState } from '../state';

@Injectable()
export default class TeaserBetStateStorageService {
    toSavedState(state: ITeaserBetState): ITeaserBetSavedState {
        return state;
    }

    fromSavedState(state: ITeaserBetSavedState): ITeaserBetState {
        if (!state) {
            return defaultTeaserBetState;
        }

        return { ...state };
    }
}
